import React from 'react'

import { useParams } from 'react-router-dom'
import Flex from 'styled-flex-component'

import { CampaignCreatorsHeader } from '@components/CampaignCreators'
import AgentSourcedCreatorListView from '@components/CreatorSearch/AgentSourcedCreatorListView/AgentSourcedCreatorListView'
import HeadTag from '@components/UI/HeadTag'
import MainLayout from '@components/UI/MainLayout'
import { withConnected404Page } from '@hocs'
import { IApplicationState } from '@store'
import { selectAgentSourcedCreatorsError } from '@store/agentSourcedCreators/selectors'
import { Container, ToastContainer } from '@tribegroup'
import CampaignCreators404 from './404'

export const CampaignCreatorsPage: React.FC = () => {
  const { token } = useParams<{ token: string }>()
  return (
    <MainLayout>
      <HeadTag id="campaignCreators.header.title" />
      <ToastContainer />
      <Container bottomInnerSpacing={3}>
        <Flex alignCenter justifyCenter column>
          <CampaignCreatorsHeader />
          <AgentSourcedCreatorListView campaignId={0} token={token} />
        </Flex>
      </Container>
    </MainLayout>
  )
}

const connected404Props = {
  component: CampaignCreators404,
  selector: (state: IApplicationState) => {
    const error = selectAgentSourcedCreatorsError(state)
    return error ? { status: 0, message: error } : undefined
  },
}

export default withConnected404Page(connected404Props)(CampaignCreatorsPage)
